import { useEffect, useState } from "react";
import { ManagementApi } from "./api";

type Connection = { configured: boolean; controller_id?: string };
export function ControllerConnectionStatus({ api, hallId }: { api: ManagementApi; hallId: string }): React.JSX.Element {
  const [loaded, setLoaded] = useState<Connection>();
  const [message, setMessage] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    void api.get<Connection>(`/v1/halls/${encodeURIComponent(hallId)}/controller-connection`, controller.signal)
      .then(value => { if (!controller.signal.aborted) setLoaded(value); })
      .catch(() => { if (!controller.signal.aborted) setMessage("Controller connection could not be verified."); });
    return () => controller.abort();
  }, [api, hallId]);
  return <section className="panel"><h3>Automatic controller connection</h3>
    <p>{loaded?.configured ? "The enrolled controller connection is configured. POS devices discover it securely from this company’s domain." : "Waiting for the company’s Controller installer to complete Domain + Save."}</p>
    {loaded?.configured && <p>Controller: {loaded.controller_id}</p>}
    {message && <p role="status">{message}</p>}
  </section>;
}
